import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useControlledSwr } from '@systemeio/util';
import { SharingStatusEnum } from 'modules/share/enum/sharing-status-enum';
import { SharingStatusInterface } from '../types/sharing-status-interface';
import { getSharingStatusPath } from '../api';
export const useSharingStatusPolling = t0 => {
  const $ = _c(7);
  const {
    sharingId,
    allowFetch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== sharingId) {
    t2 = () => getSharingStatusPath(sharingId);
    $[1] = sharingId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      refreshInterval(latestData) {
        if (!latestData || latestData.status === SharingStatusEnum.Running) {
          return 1500;
        }
        return 0;
      },
      errorRetryCount: 3
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: sharingStatus,
    mutate
  } = useControlledSwr(t2, fetcher, t3, allowFetch);
  let t4;
  if ($[4] !== mutate || $[5] !== sharingStatus) {
    t4 = {
      sharingStatus,
      mutate
    };
    $[4] = mutate;
    $[5] = sharingStatus;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};